import React from 'react';
import { cn } from '@/lib/cn';

export interface MaskedTextProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Additional CSS classes for styling */
  className?: string;
}

export function MaskedText({ className = '', ...props }: MaskedTextProps) {
  return <div className={cn('bg-[#64748B] h-4 ', className)} {...props} />;
}
